import styled, {keyframes} from "styled-components";
import {confettiStripsCharacteristics} from "./confetti-props";

const confettiStripKeyframes = keyframes`
    0% {
        stroke-dashoffset: 100;
        opacity: 0;
    }
    30% {
        opacity: 0.5;
    }
    50% {
        opacity: 0.7;
    }
    80% {
        opacity: 1;
    }
    100% {
        stroke-dashoffset: -1000;
        opacity: 0;
    }
`;

export const ConfettiStripsSvgPathBox = styled.path<{
    confettiStripIndex: number;
}>`
    stroke-dasharray: 500;
    stroke-dashoffset: 100;
    transform-origin: center;
    stroke-width: ${props => confettiStripsCharacteristics[props.confettiStripIndex].size}px;
    stroke: ${props => confettiStripsCharacteristics[props.confettiStripIndex].color};

    animation: ${confettiStripKeyframes} 1.5s linear forwards;

`;